import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ControlBase } from '../../base/base.component';
import { DatePickerType } from '@form';

@Component({
  selector: 'date-common',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export class DateCommon extends ControlBase {
  protected readonly DEFAULT_SUBTYPE: DatePickerType = 'date';
  date = input<any>();
  subType = input<DatePickerType>(this.DEFAULT_SUBTYPE);
}
